import { Box, Typography, Menu, MenuItem, IconButton, Avatar, alpha, useTheme } from "@mui/material";
import { ExitToApp, LockOutlined } from "@mui/icons-material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { tokens } from "../../theme";

const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleChangePassword = () => {
    handleMenuClose();
    navigate('/update-password');
  };

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to log out?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Log Out",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("accessToken");
        navigate("/");
      }
    });
  };

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      p={2}
      color={'#6e0506'}
      backgroundColor={colors.primary[400]}
    >
      <Box display="flex" borderRadius="3px">
        <Box display="flex" justifyContent="center" alignItems="center">
          <img
            alt="profile-user"
            width="50vh"
            height="40vh"
            src={`../../assets/user.png`}
            style={{ cursor: "pointer", borderRadius: "20%" }}
          />
        </Box>{" "}
        <Typography
          variant="h2"
          color={'#6e0506'}
          fontWeight="bold"
          sx={{ m: "10px " }}
        >
          Open Curtains Casting
        </Typography>
      </Box>

      {/* <Button
        color="inherit"
        startIcon={<ExitToApp />}
        sx={{
          fontWeight: "600",
          fontSize: "20px",
          textTransform: "none",
          color: alpha(colors.grey[300], 0.6),
          "&:hover": {
            backgroundColor: "#f2f0f0", // Red on hover
            color: "#941416", 
            fontWeight: "600",
            // White text on hover
          },
        }}
        
        onClick={handleLogout}
      >
        Log Out
      </Button> */}
      <Box>
        <IconButton onClick={handleMenuOpen}>
          <Avatar
            alt="Profile"
            // src="../../assets/user.png"
            sx={{ width: 40, height: 40,bgcolor:'#6e0506' }}
          />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          PaperProps={{
            sx: {
              mt: 1,
              backgroundColor: colors.primary[400],
            }
          }}
        >
          <MenuItem onClick={handleChangePassword} sx={{
            color: '#6e0506',
            '&:hover': { backgroundColor: alpha('#6e0506') }
          }}>
            <LockOutlined sx={{ mr: 1 }} />
            Change Password
          </MenuItem>
          <MenuItem onClick={handleLogout} sx={{
            color: '#6e0506',
            '&:hover': { backgroundColor: alpha('#6e0506') }
          }}>
            <ExitToApp sx={{ mr: 1 }} />
            Logout
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};

export default Topbar;
